import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
type CommandGroupProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Group>;
const CommandGroup = forwardRef<HTMLDivElement, CommandGroupProps>((t0, ref) => {
  const $ = _c(11);
  let className;
  let heading;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      heading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = heading;
    $[3] = props;
  } else {
    className = $[1];
    heading = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cx("not-first:mt-2 px-1 text-caption-1", "[&_[cmdk-group-heading]]:text-tertiary [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:user-select-none", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== heading || $[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = <CommandPrimitive.Group ref={ref} heading={heading} className={t1} {...props} />;
    $[6] = heading;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
export default CommandGroup;